/**
 * Block 13 PR-G Phase 6.5E Item H — RegionPicker (native HTML `<select>`).
 *
 * **Aibek visual verify round 3 (2026-05-24):** добавить выпадающий список
 * «Регион» в SectionPreamble. По умолчанию подставляется регион из профиля
 * пользователя (через `selectContractRegion(state)` — derived из templateKey),
 * но user может выбрать другой для конкретного договора (Casе use case:
 * KZ-мебельщик оформляет договор с RU/UZ клиентом и хочет применить
 * соответствующий региональный шаблон).
 *
 * **Каскад с LanguagePicker** (через reducer SET_CONTRACT_REGION):
 * при смене region templateKey автоматически пересчитывается — если текущий
 * язык доступен в новом регионе, он сохраняется; иначе downgrade на default
 * per region. LanguagePicker re-renders с новым available options
 * автоматически (он подписан на state.templateKey → selectContractRegion).
 *
 * Currency code НЕ меняется автоматически (per Aibek decision: user-explicit
 * override через chip-segment в SectionCostAndTerms).
 *
 * Native `<select>` styling matches LanguagePicker.tsx pattern (Q1 decision
 * Phase 6.5D — Aibek prefers native dropdowns over bottom sheets).
 *
 * Reference:
 *   - Block_13_PR_G_phase_6.5E_start.md Item H
 *   - Phase 6.5D LanguagePicker.tsx (mirror pattern)
 */

import { CONTRACT_REGIONS, type ContractRegion } from '@pomoshnik/shared';

const REGION_LABELS: Record<ContractRegion, string> = {
  kz: 'Казахстан',
  ru: 'Россия',
  uz: 'Узбекистан',
};

const LABEL_CLASS = 'block text-sm font-semibold text-ink/80 mb-1';
const SELECT_CLASS =
  'w-full min-h-tap px-3 pr-10 rounded-xl border-[1.5px] border-accent bg-card text-base text-ink ' +
  'focus-visible:ring-2 focus-visible:ring-cta focus-visible:outline-none ' +
  'appearance-auto';

export interface RegionPickerProps {
  region: ContractRegion;
  onChange: (next: ContractRegion) => void;
}

export function RegionPicker({ region, onChange }: RegionPickerProps) {
  return (
    <div>
      <label htmlFor="contract-region-select" className={LABEL_CLASS}>
        Регион
      </label>
      <select
        id="contract-region-select"
        value={region}
        onChange={(e) => onChange(e.target.value as ContractRegion)}
        data-testid="contract-region-select"
        className={SELECT_CLASS}
      >
        {CONTRACT_REGIONS.map((r) => (
          <option key={r} value={r}>
            {REGION_LABELS[r]}
          </option>
        ))}
      </select>
      <p className="mt-1 text-xs text-ink/60" data-testid="contract-region-hint">
        например: Казахстан
      </p>
    </div>
  );
}
